<template>
  <div 
    class="inner-container"
  >
  <input
              type="file"
              ref="file" 
              :disabled="isSaving"
              @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
              accept="image/*"
              class="input-file"
              style="display:none" />
    <v-btn
      fixed
      fab
      bottom
      right
      dark
      @click="$store.dispatch('updateShowingModal', {active: true, name: 'addJewelry'})"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-navigation-drawer
    stateless
    value="true"
    fixed
    style="padding-top:64px"
  >
    <v-list>
      <v-list-tile style="font-family: 'DINPro Bold'">Filters</v-list-tile>
        <v-radio-group v-model="currentFilter" column style="padding-left:16px;">
          <v-radio label="None" value="none"></v-radio>
          <v-radio label="Awarded" value="awarded"></v-radio>
         <!-- <v-radio label="New Collection" value="isNew"></v-radio> -->
          <v-radio label="Category" value="catagory"></v-radio>
          <v-radio-group v-if="currentFilter=='catagory'" v-model="catagory" column style="padding-left:16px;">
            <v-radio v-for="(item,index) in $store.state.catagories" :key="index" :label="item.title" :value="item"></v-radio>
          </v-radio-group>
        </v-radio-group>
      <v-list-tile style="font-family: 'DINPro Bold'">Sort By</v-list-tile>
        <v-radio-group v-model="currentSort" column style="padding-left:16px;">
          <v-radio label="None" value="none"></v-radio>
          <v-radio label="Title" value="title"></v-radio>
          <v-radio label="Created At" value="createdAt"></v-radio>
        </v-radio-group>
  
    </v-list>
  </v-navigation-drawer>
     <v-layout style="padding-left: 300px;">
          <v-container grid-list-sm fluid>
            <v-layout row wrap>
                <v-card tile v-for="(item,index) in $store.state.jewelry" :key="index" style="margin:1rem">
                  <v-card-title primary-title>
                    <div>
                      <v-text-field
                        v-if="editing && editingObj._id == item._id"
                        v-model="newTitle"
                        label="Title"
                        required
                        style="font-family: 'DINPro Regular'"
                      ></v-text-field>
                      <h3 v-else center style="font-family: 'DINPro Regular'">{{ item.title}}</h3>
                      <v-switch
                          v-if="editing && editingObj._id == item._id"
                          v-model="newAward"
                          :label="`Awarded: ${newAward.toString()}`"
                      ></v-switch>
                      <v-text-field
                        v-if="editing && editingObj._id == item._id && newAward"
                        v-model="newAwardText"
                        label="Award Title"
                        style="font-family: 'DINPro Regular'"
                      ></v-text-field>
                      <p style="font-family: 'DINPro Light'">{{item.catagory.title}}</p>
                      <v-icon style="position:absolute;top:1rem;right:1rem" v-if="item.isAward">done</v-icon>
                    </div>
                  </v-card-title>
                  <v-img
                    :src="item.imageUrl"
                    :lazy-src="item.imageUrl"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    :class="{'hover-img': editing && editingObj._id == item._id}"
                    @click="changeImg((editing && editingObj._id == item._id))"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                  <v-card-actions>
                    <v-btn v-if="editing && editingObj._id == item._id" @click="setEdit(false)" flat color="primary" style="font-family: 'DINPro Light'">cancel</v-btn>
                    <v-btn v-else @click="setEdit(item)" flat color="primary" style="font-family: 'DINPro Light'">edit</v-btn>
                    <v-btn v-if="editing && editingObj._id == item._id" @click="saveEdit(item._id)" flat color="blue" style="font-family: 'DINPro Light'">save</v-btn>
                    <v-btn v-else @click="removeJewelry(item._id)" flat color="red" style="font-family: 'DINPro Light'">remove</v-btn>
                  </v-card-actions>
                </v-card>
            </v-layout>
     </v-container>
     </v-layout>
  </div>
</template>

<script>
import { CMS } from "../../api";


const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  created() {
    CMS.getCatagories(this, response => {
      this.catagory = this.$store.state.catagories[0]
    });
    this.getJewelry()
  },
  watch: {
    currentFilter: {
      handler: function(val, oldVal) {
        console.log(val)
        this.getJewelry()
      }
    },
    currentSort: {
      handler: function(val, oldVal) {
        console.log(val)
        this.getJewelry()
      }
    },
    catagory: {
      handler: function(val, oldVal) {
        console.log(val)
        this.getJewelry()
      }
    }
  },
  data() {
    return {
      editing: false,
      editingObj: null,
      newTitle: "",
      currentFilter: "none",
      currentSort: 'none',
      catagory: '',
      isSaving: false,
      fileUrl: '',
      currentStatus: 0,
      newAward: false,
      newAwardText: ''
    };
  },
  computed: {},
  methods: {
    setEdit(jewelry) {
      if (!jewelry) {
        this.editing = false;
        this.editingObj = null;
        this.newTitle = "";
        return;
      }
      this.editing = true;
      this.editingObj = jewelry;
      this.newTitle = jewelry.title;
      this.newAward = jewelry.isAward
      this.newAwardText = jewelry.awardTitle
    },
    getJewelry() {
      console.log(this.catagory)
      let catagory = this.catagory
      if (catagory._id) catagory = catagory._id
      CMS.getJewelry(this, this.currentFilter, this.currentSort, catagory, response => {});
    },
    removeJewelry(jewelryId) {
      CMS.editJewelry(this, jewelryId, { isActive: false }, response => {
        CMS.getJewelry(this, response => {});
      });
    },
    saveEdit(jewelryId) {
      let { newTitle, currentFilter, currentSort, newAward, newAwardText } = this;
      console.log(newAward)
      console.log(newAwardText)
      CMS.editJewelry(this, jewelryId, { title: newTitle, isAward: newAward, awardTitle: newAwardText }, response => {
        this.getJewelry()
        this.setEdit(false);
      });
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(file, name) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      CMS.getSignedUrl(this, file, response => {
        if (response && response.data && response.data.signedRequest) {
          this.fileUrl = `https://s3.amazonaws.com/marofsb/images/${
            response.data.filename
          }`;
          this.uploadToS3(file, response.data.signedRequest);
        } else alert("danger will robinson, we have an error");
      });
    },
    uploadToS3(file, signedRequest) {
      CMS.uploadToS3(this, file, signedRequest, response => {
        console.log(response)
        if (parseInt(response.status) == 200) {
          this.success = true;
          this.currentStatus = STATUS_SUCCESS;
          console.log('cool')
          console.log(this.fileUrl)
          // make api call to update jewelry
          CMS.editJewelry(this, this.editingObj._id, { imageUrl: this.fileUrl }, response => {
            this.getJewelry()
            this.setEdit(false);
          });
          return;
        }
        alert("something failed, sorry, try again");
      });
    },
    filesChange(fieldName, fileList) {
      if (!fileList.length) return;
      this.save(fileList[0]);
    },
    changeImg(isValid) {
      if (!isValid) return
      this.$refs.file.click()
    }
  }
};
</script>
<style>
.v-label {
  font-family: 'DINPro Light';
}
</style>
<style scoped>
.inner-container {
  background-color: white;
  border: 1px solid black;
  padding-top: 5%;
}
.hover-img:hover {
  cursor: pointer;
}
.crown-icon {
  height: 2rem;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// Jewelry.vue?7c3f6a58